import { ApiService } from '../ApiService';
import { type MarketBuyRequest, type MarketBuyResponse, type MarketPrize } from './types';

export const getMarketPrize = async (id: number): Promise<MarketPrize> => {
  const { data } = await ApiService.instance.get(`v1/market/prize/${id}`);
  return data;
};

export const buyMarketPrize = async (
  payload: MarketBuyRequest
): Promise<MarketBuyResponse> => {
  const { data } = await ApiService.instance.post('v1/market/buy', payload);
  return data;
};
